<template>
    <v-dialog v-model="dialog.show" persistent  max-width="800px">
       
            
            <v-card>
                <!-- <v-card-title class="title-page ">Associação de Credor</v-card-title> -->
                <v-card-text>
            <v-row>
                <v-col :cols="12">
                    <br>
               
                    <span id="title" class="page-title">Adicionar Responsável</span>
    
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-card class="filter-card">
                        <v-card-title class="filter-card-title">Filtro</v-card-title>
                        <v-card-text>
                            <v-form @submit.prevent="load()">
                                <v-row>
                                    <!-- <v-col>   
                                        <v-autocomplete dense :items="dataset.clients" label="Caso" v-model="dataList.filter.client"
                                            item-value="id" item-text="name" outlined hide-details="auto" no-data-text="Nenhum caso encontrado">
                                        </v-autocomplete>
                                    </v-col> -->
                                    <v-col>
                                        <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name" hide-details
                                            outlined></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <v-text-field dense id="registration" label="CPF" v-model="dataList.filter.registration" hide-details
                                            outlined></v-text-field>
                                    </v-col>
                                    <!-- <v-col>
                                        <v-text-field dense id="email" label="Email" v-model="dataList.filter.email" hide-details
                                            outlined></v-text-field>
                                    </v-col> -->
                                    
                                     <!-- <v-col>   
                                        <v-autocomplete dense :items="dataset.clients" label="Caso" v-model="dataList.filter.client"
                                            item-value="id" item-text="name" outlined hide-details="auto" no-data-text="Nenhum caso encontrado">
                                        </v-autocomplete>
                                    </v-col> -->
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">  
                                                <v-btn v-on="on" id="btnFilter" type="submit" color="primary" dark elevation="2"
                                                    >Filtrar</v-btn>
                                            </template>
                                            <span>Filtrar dados selecionados</span>
                                        </v-tooltip>     
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-card class="table-card">
                        <v-card-title class="table-card-title">Responsáveis</v-card-title>
                        <v-card-text>
                            <v-data-table
                                :headers="dataList.headers"
                                :items="dataList.data"
                                :server-items-length="dataList.count"
                                @update:items-per-page="pageSizeChanged"
                                @update:page="pageChanged"
                                :disable-sort="true"
                                :loading="dataList.loading"
                                no-data-text="Nenhum responsável foi encontrado"
                                loading-text="Carregando dados..."
                                class="app-table hover-table"
                                :options.sync="dataList.options"
                                :footer-props="dataList.footerOptions"
                            >
                                <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                                </template>

                                <!-- <template v-slot:[`item.name`]="{ item }">
                                <strong> {{ item.name && item.client.name ? item.client.name : 'N/A' }}</strong>
                                </template> -->

                                <!-- <template v-slot:[`item.actions`]="{ item }">
                                <v-icon :disabled="!$check('Document', 'PATCH')" @click="viewItem(item)" size="large" class="me-2">
                                    mdi-pencil-outline
                                </v-icon>
                                <v-icon :disabled="!$check('Document', 'DELETE')" @click="deleteItem(item)" size="large">
                                    mdi-delete-outline
                                </v-icon> 
                                </template>-->
                                <template v-slot:[`item.checkbox`]="{ item }">
                                <v-checkbox v-model="item.selected" :value="item.selected" @change="handleCheckboxChange(item)"></v-checkbox>
                                </template>
                            </v-data-table>
                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-actions>
                            <div class="button">
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn v-on="on" @click="associateSelectedAnswerable()" color="primary" dark elevation="2" :loading="dataset.loading">
                                            Adicionar
                                        </v-btn>
                                    </template>
                                    <span>Adicionar responsável selecionado</span>
                                </v-tooltip>
                            </div>
                            <div>
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn v-on="on" color="grey" text @click.native="closeModal()">Cancelar</v-btn>
                                    </template>
                                    <span>Fechar</span>
                                </v-tooltip>
                            </div>
                        </v-card-actions>

                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
        </v-card>
      
    </v-dialog>
  </template>

<script>
import 'moment/locale/pt-br';

//import { eventHub } from "@/main";

import axios from "axios"

import string from "@/common/util/string"
import object from "@/common/util/object"
import _ from 'lodash';

export default {

    data: () => ({
        selectedItems: [],
        dataset: {
            data: {},
            loading: false,
            answerables: [],
        },
        dataList: {
            filter: {
                name: "",
                email: "",
                registration: "",
            },
            headers: [
                { text: '', value: 'checkbox', sortable: false },
                { text: "Nome", value: "name" },
                { text: "CPF", value: "registration" },
               // { text: 'Tipo', value: "type" },
                { text: "Criado em", value: "created_at" },
               //{ text: 'Ações', value: 'actions', sortable: false },
               
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },

        dialog: {
            show: false,
            resolve: null,
            reject: null,
        },
    }),


    methods: {

        handleCheckboxChange(selectedItem) {
            
            if(this.dataset.data){

                const index = this.selectedItems.findIndex(item => item.id === selectedItem.id);

                if (index !== -1) {
                    this.selectedItems.splice(index, 1);
                } else {
                    this.selectedItems.push({
                        id: selectedItem.id,
                        name: selectedItem.name,
                        saved: false
                    });
                }
                
                this.dataList.data.forEach(item => {
                    const isSelected = this.selectedItems.some(selected => selected.id === item.id);
                    item.selected = isSelected;
                });

                this.$forceUpdate();
                
                console.log("items: ", this.selectedItems)
                console.log("dataList: ", this.dataList.data)
                
            }
            
        },

        

        open() {
            this.dialog.show = true;
                        
            return new Promise((resolve, reject) => {
                this.dialog.resolve = resolve;
                this.dialog.reject = reject;
            });
            
        },
        closeModal(){

            this.dialog.show = false;
        },

        close() {
            this.dialog.resolve(this.selectedItems)

            this.dataList.data = [];
            
            this.dialog.show = false;
        },

        goBack() {
            this.dataset.data = {};
            this.close();
        },

        setData(data) {
            console.log('set data ', data)
            this.dataset.data = data;
        },

        pageChanged(page) {            
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {    
            this.dataList.options.size = size;
            this.load(true);
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },


        async load() {
    
            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;


            if (this.dataset.data && this.dataset.data.length > 0) {
                this.dataset.data.forEach(item => {
                    this.selectedItems.push({
                        id: item.id,
                        name: item.name,
                        saved: false
                    });
                });
            }

            try {
                const result = await axios.get('/api/v1/answerables', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

                if (this.dataList.data) {
                    this.dataList.data = result.data.content.data.map(item => {
                        const selectedItem = this.selectedItems.find(selected => selected.id === item.id);
                        if (!item.hasOwnProperty('selected')) {
                            item.selected = false;
                        }
                        if (selectedItem) {
                            item.selected = true;
                        }
                        return item;
                    });
                } else {
                    this.dataList.data = result.data.content.data.map(item => {
                        const selectedItem = this.selectedItems.find(selected => selected.id === item.id);
                        item.selected = selectedItem ? true : false;
                        return item;
                    });
                }

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;

            }

        },


        async associateSelectedAnswerable() {
       
            if (!this.selectedItems) {
                this.$dialog.notify.error("Selecione um responsável!", { position: "top-right", timeout: 5000 });
                return; 
            }

            this.goBack()

        },
        
    }
};


</script>

<style lang="scss">

.title-page {
    color: var(--v-primary-base);
    //font-family: "Montserrat" !important;
    font-size: 28px !important;
    //font-style: bold !important;
    font-weight: 600 !important;
    line-height: 20px !important;
    text-align: center !important;
}

p {
    text-align: justify;
}

.editor-container {
  height: 500px; 
  overflow-y: auto; 
}


</style>
